export default __webpack_public_path__ + "static/media/snp.71b9037e.png";